import React from "react";

import {
  DiscoveryProductTileBrandInfo,
  discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter,
} from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/DiscoveryProductTileBrandInfo";

import { ProductClickForSearchPageParameters } from "../../productTileActions/useOnProductClickForSearchPage";

import { BrandInfoProps } from "./brandInfoProps";

interface IProps {
  data: BrandInfoProps;
}

export const BrandInfo: React.FC<IProps> = ({ data }) => {
  const trackingParams: ProductClickForSearchPageParameters = {
    token: data.token,
    isPromoted: data.isPromoted,
    impressionId: data.impressionId,
    promotedBy: data.promotedBy,
    badgeList: data.badgeList,
    bestImage: data.bestImage,
    images: data.images,
  };

  if (!data) {
    return null;
  }

  return (
    <DiscoveryProductTileBrandInfo
      brand={discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter(data)}
      trackingParams={trackingParams}
      isLoggedInRetailer={data.isLoggedInRetailer}
      dataTestId={data.dataTestId}
      isLoaded={!!data}
      avgBrandReviewRating={data.avgBrandReviewRating}
      brandReviewCount={data.brandReviewCount}
      brandPromoText={data.brandPromoText}
      insiderBadgeProps={data.insiderBadgeProps}
      isHighlightedProductForPromotionalEvent={
        data.isHighlightedProductForPromotionalEvent
      }
      selectedProductOptionToken={data.selectedProductOptionToken}
    />
  );
};
